import React, { useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Select, Checkbox, notification,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';
import ProductActions from '@Actions/productActions';
import ShopifyIntegrationActions from '@Actions/integrations/shopifyIntegrationActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';
import ProductFilterV2 from '@Components/Common/ProductFilterV2';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;

const ShopifyADHOCForm = ({
  callback, createADHOCLoading, createADHOC, selectedSO,
}) => {
  const [productSkuId, setProductSkuId] = useState('');
  const [availableLocations, setAvailableLocations] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState('');
  const [quantity, setQuantity] = useState('');
  const [discount, setDiscount] = useState(null);
  const [discountType, setDiscountType] = useState(null);
  const [description, setDescription] = useState(null);
  const [notifyCustomer, setNotifyCustomer] = useState(false);
  const [remarks, setRemarks] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);

  const productsToExclude = selectedSO?.sales_order_lines?.map((soLine) => soLine?.tenant_product_id);

  const isDataValid = () => {
    let isValid = true;
    if (discount) {
      if (!discountType || !description) {
        isValid = false;
      }
    }
    if (!remarks) isValid = false;
    return isValid;
  };

  const addADHOC = () => {
    setFormSubmitted(true);

    if (productSkuId && selectedTenant && quantity && isDataValid()) {
      const payload = {
        shop_name: selectedSO?.shopify_so_object?.shop_name,
        order_id: selectedSO?.order_id,
        product_sku_id: productSkuId,
        tenant_id: selectedTenant,
        quantity: Number(quantity),
        discount: Number(discount),
        discount_type: discountType,
        description,
        notify_customer: notifyCustomer,
        remarks,
      };
      createADHOC(payload, () => {
        callback();
      });
    } else {
      notification.open({
        type: 'warning',
        message: 'Please provide input for all mandatory fields',
        duration: 4,
        placement: 'top',
      });
    }
  };

  const discountTypeOptions = [
    { label: 'Percent', value: 'percent' },
    { label: 'Fixed Amount', value: 'fixed_amount' },
  ];

  return (
    <Fragment>
      <div className="create-shopify-adhoc__wrapper" style={{ marginBottom: '40px' }}>
        <div className="ant-row">

          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="orgInputContainer">
              <div className="orgFormLabel">
                Select Product
                {' '}
                <span style={{ color: 'red' }}>*</span>
              </div>
              <ProductFilterV2
                record={{ product_sku_id: productSkuId }}
                productTypes={['STORABLE', 'SERVICE', 'BUNDLE', 'NON_STORABLE']}
                handleProductChangeValue={() => {}}
                handleProductChange={(value) => {
                  setProductSkuId(value?.product_sku_id);
                  setAvailableLocations(value?.available_locations);
                }}
                required
                showError={formSubmitted}
                isSalesProduct
                excludedProducts={productsToExclude}
                tenantDepartmentId={selectedSO?.tenant_department_id}
                filterReservedQuantity
                isRegularSelector
                shopifyProductsOnly
              />
            </div>
          </div>
          {productSkuId && (
            <Fragment>
              <div className="ant-col-md-24 ant-col-xs-24">
                <div className="orgInputContainer">
                  <div className="orgFormLabel">
                    Select Fulfillment Location
                    {' '}
                    <span style={{ color: 'red' }}>*</span>
                  </div>
                  <PRZSelect
                    value={selectedTenant}
                    filterOption={false}
                    disabled={!productSkuId}
                    onChange={(value) => {
                      setSelectedTenant(value);
                    }}
                    showSearch
                    placeholder="Select a products"
                    showError={formSubmitted && !selectedTenant}
                    errorName="*Please select a shopify product"
                    errorClassName="input-error"
                  >
                    {availableLocations
                      ?.map((item) => (
                        <Option key={item?.tenant_id} value={item?.tenant_id}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ marginRight: '5px' }}>
                              {`${item?.tenant_name}`}
                            </div>
                          </div>
                        </Option>
                      ))}
                  </PRZSelect>
                </div>
              </div>
              <div className="ant-col-md-24 ant-col-xs-24">
                <H3FormInput
                  name="quantity"
                  type="number"
                  label="Quantity"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  containerClassName="orgInputContainer"
                  placeholder=""
                  disabled={createADHOCLoading}
                  onChange={(event) => setQuantity(event.target.value)}
                  value={quantity}
                  required
                  maxlength="5"
                  showError={formSubmitted && !quantity}
                />
              </div>
              <div className="ant-col-md-24 ant-col-xs-24">
                <H3FormInput
                  name="discount"
                  type="number"
                  label="Discount"
                  containerClassName="orgInputContainer"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  placeholder=""
                  disabled={createADHOCLoading}
                  onChange={(event) => setDiscount(event.target.value)}
                  value={discount}
                  maxlength="5"
                />
              </div>
              {discount && (
                <div className="ant-col-md-24 ant-col-xs-24">
                  <div className="orgInputContainer">
                    <label className="orgFormLabel">
                      Discount Type
                      <span style={{ color: 'red' }}>{'  *'}</span>
                    </label>
                    <PRZSelect
                      value={discountType}
                      disabled={createADHOCLoading}
                      onChange={(value) => {
                        setDiscountType(value);
                      }}
                      options={discountTypeOptions}
                      showError={formSubmitted && !discountType}
                      errorName="*Please select control frequency"
                      errorClassName="input-error"
                    />
                  </div>
                </div>
              )}
              {discount && (
                <div className="ant-col-md-24 ant-col-xs-24">
                  <H3FormInput
                    name="description"
                    type="text"
                    label="Description"
                    containerClassName="orgInputContainer"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput"
                    placeholder=""
                    onChange={(event) => setDescription(event.target.value)}
                    value={description}
                    disabled={createADHOCLoading}
                    maxlength="100"
                    required
                    showError={formSubmitted && !description}
                  />
                </div>
              )}
              <div className="ant-col-md-24 ant-col-xs-24">
                <div className="orgInputContainer create__right-input">
                  <Checkbox
                    disabled={createADHOCLoading}
                    checked={notifyCustomer}
                    onChange={() => {
                      setNotifyCustomer(!notifyCustomer);
                    }}
                  >
                    <div style={{ fontWeight: '600', fontSize: '12px' }}>Notify Customer</div>
                  </Checkbox>
                </div>
              </div>
              <div className="ant-col-md-24">
                <div className="orgInputContainer">
                  <H3Text required text="Remarks" className="orgFormLabel" />
                  <textarea
                    className="orgFormInput"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    disabled={createADHOCLoading}
                  />
                </div>
              </div>
            </Fragment>
          )}
          <div className="custom-drawer__footer">
            <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
              <H3Button
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                text="Add Product"
                onClick={() => addADHOC()}
                isLoading={createADHOCLoading}
                disabled={createADHOCLoading}
                style={{
                  width: '160px',
                  borderRadius: '5px',
                  padding: '7px 0px',
                  marginLeft: '0',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, ProductReducers, ShopifyIntegrationReducers,
}) => ({
  user: UserReducers.user,
  products: ProductReducers.products,
  createADHOCLoading: ShopifyIntegrationReducers.createADHOCLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getProducts: (keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct) => dispatch(ProductActions.getProducts(keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct)),
  createADHOC: (payload, callback) => dispatch(ShopifyIntegrationActions.createADHOC(payload, callback)),
});

ShopifyADHOCForm.propTypes = {
  createADHOC: PropTypes.func,
  createADHOCLoading: PropTypes.bool,
  selectedSO: PropTypes.any,
  callback: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShopifyADHOCForm));
